export const enum FieldType {
	None = 'none',
	Array = 'Array',
	Date = 'Date',
	Number = 'Number',
	String = 'Text',
}
